import Link from "next/link";
import Button from "components/shared/button/Button";
import Container from "components/shared/container/Container";

import {
    DoubleCardStyled,
    Content,
    TopContent,
    DoublerImage,
    BottomContent,
    Title,
    Description
} from "./DoubleCard.styled";

export default function DoubleCard() {
    return (
        <DoubleCardStyled>
            <Container>
                <Content>
                    <TopContent>
                        <DoublerImage
                            src="/images/doubler-desktop.webp"
                            alt="doubler"
                            loading="lazy"
                            width={495}
                            height={393}
                            layout="intrinsic"
                        />
                    </TopContent>
                    <BottomContent>
                        <Title>
                            <span>Verdubbel</span> jouw cadeaukaart waarde
                        </Title>
                        <Description>
                            Maak kans op een verdubbeling van het waarde op je
                            Lees! Cadeaukaart. Vul meteen je kaartnummer in en
                            doe mee!
                        </Description>
                        <Link href="/verdubbelaar" passHref>
                            <Button element="a">Ik doe mee!</Button>
                        </Link>
                    </BottomContent>
                </Content>
            </Container>
        </DoubleCardStyled>
    );
}
